import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IAtendente } from '../data/atendente';
import { AtendenteService } from '../services/atendente.service';


@Component({
  selector: 'app-list-atendentes',
  templateUrl: './list-atendentes.component.html',
  styleUrls: ['./list-atendentes.component.scss']
})
export class ListAtendentesComponent {
  @Input() atendentes: IAtendente[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };

  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  ERoleAdminString = ERoleAdminString;
  cpfVisivelIds = new Set<string>();

  toggleCpfVisivel(id: string): void {
    if (this.cpfVisivelIds.has(id)) {
      this.cpfVisivelIds.delete(id);
    } else {
      this.cpfVisivelIds.add(id);
    }
  }

  constructor(
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly atendentesService: AtendenteService,
    private readonly toastService: ToastService
  ) { }

  public toogleAtendenteStatus(usuarioId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} o Atendente?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.atendentesService.desativarAtendente(usuarioId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            // if (resposta.isSucceed) {
            this.recarregarListagem.emit();
            // }
          });
        } else {
          this.atendentesService.ativarAtendente(usuarioId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            // if (resposta.isSucceed) {
            this.recarregarListagem.emit();
            // }
          });
        }
      });
  }
}